const NEUTRAL_THRESHOLD_PERCENTAGE = 0.1;

export function getStatisticVariant(
  sold: number,
  stock: number
): 'success' | 'neutral' | 'warning' {
  const difference = Math.abs(sold - stock);
  const threshold = stock * NEUTRAL_THRESHOLD_PERCENTAGE;

  if (difference <= threshold) {
    return 'neutral';
  }
  if (sold > stock) {
    return 'success';
  }
  return 'warning';
}
